import {gql} from '@apollo/client';

import type {DocumentNode} from '@apollo/client';

export default function tag(...args: Parameters<typeof gql>): DocumentNode {
  let compiled: DocumentNode | null = null;

  return {
    get kind() {
      if (!compiled) {
        compiled = gql(...args);
      }

      return compiled.kind;
    },

    get definitions() {
      if (!compiled) {
        compiled = gql(...args);
      }

      return compiled.definitions;
    },

    get loc() {
      if (!compiled) {
        compiled = gql(...args);
      }

      return compiled.loc;
    },
  };
}
